import { EGetFlatStatsActionType } from './types';
import { getAvgPriceAndMortgageRate, TFlatStatsResult } from '../../services/getAvgPriceAndMortgageRate';
import { IFlatStats } from '../../types/flatStats';
import { TThunkAction } from '../../types/redux/thunk';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const setStatusLoading = actionGenerator<EGetFlatStatsActionType.Loading>(EGetFlatStatsActionType.Loading);
const setStatusSucceed = actionGenerator<EGetFlatStatsActionType.Succeed, IFlatStats>(EGetFlatStatsActionType.Succeed);
const setStatusFailed = actionGenerator<EGetFlatStatsActionType.Failed, string>(EGetFlatStatsActionType.Failed);

export function getFlatStats(): TThunkAction<Promise<TFlatStatsResult>> {
  return async (dispatch, getState, context) => {
    const {
      fieldsState: { address },
    } = getState();

    dispatch(setStatusLoading());

    const roomCoastResult = await getAvgPriceAndMortgageRate(context, { geoAddress: address?.value });

    if (!roomCoastResult.success) {
      dispatch(setStatusFailed(roomCoastResult.message));

      return roomCoastResult;
    }

    dispatch(setStatusSucceed(roomCoastResult.data));

    return roomCoastResult;
  };
}
